module.exports = __webpack_public_path__ + "static/img/7.602bfcc5.png";